import { IGeocodeCoordinatesSchema } from '../../../repositories/monolith-python/v2/geocode';
import { ICoordinates } from '../../../types/reducers/offer';

export const mapCoordinates = (coordinatesRaw: IGeocodeCoordinatesSchema): ICoordinates => {
  const { lat, lng } = coordinatesRaw;

  return { lat, lng };
};
